import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { ZoneGeograficheComponent } from 'src/app/admin/zone-geografiche/zone-geografiche.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => ZonaGeograficaPickerComponent) },
  ],
  selector: 'zona-geografica-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class ZonaGeograficaPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(ZoneGeograficheComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
